import { inject } from 'vue';
import useCache from './useCache';

import {
  registerProductBlockKey,
  unregisterProductBlockKey,
} from '@/composables/useDynamicProductListing';

export default function (options: any) {
  const { subscribe, unsubscribe } = useCache();

  const registerProductListingBlock = inject(registerProductBlockKey, () => {});
  const unregisterProductListingBlock = inject(
    unregisterProductBlockKey,
    () => {}
  );

  const handler = (data: any) => {
    options.setProducts(buildProductData(data));
  };

  const registerProductBlock = (blockValue: any, options: any) => {
    if (
      isProductsByRelationDataSource(blockValue) ||
      isProductsByConditionDataSource(blockValue)
    ) {
      subscribe(getProductBlockCacheKey(blockValue), handler, {
        immediate: true,
      });
    } else {
      registerProductListingBlock?.(blockValue._uid, options);
    }
  };

  const unregisterProductBlock = (blockValue: any) => {
    if (
      isProductsByRelationDataSource(blockValue) ||
      isProductsByConditionDataSource(blockValue)
    ) {
      if (blockValue) {
        unsubscribe(getProductBlockCacheKey(blockValue), handler);
      }
    } else {
      unregisterProductListingBlock?.(blockValue._uid);
    }
  };

  return {
    registerProductBlock,
    unregisterProductBlock,
    inferProductDetailsContext,
  };
}

export function getProductBlockCacheKey(block: any) {
  const relationName = block.relation?.relation?.value
    ? `::r:${block.relation.relation.value}`
    : '';
  const baseProductId = block.baseProductId
    ? `::bp:${block.baseProductId}`
    : '';
  const variantId = block.variantId ? `::v:${block.variantId}` : '';

  return `products:block:${block._uid}${relationName}${baseProductId}${variantId}`;
}

export function isProductsByRelationDataSource(block: any): Boolean {
  return (
    block.relation?.relation?.value || block.baseProductId || block.variantId
  );
}

export function isProductsByConditionDataSource(block: any): Boolean {
  return block.filter?.filter?.length > 0;
}

export function isProductDetailsPage(data: any) {
  return (data.component?.toLowerCase() || '') === 'product';
}

export function inferProductDetailsContext(route: any, page: any, block: any) {
  if (isProductDetailsPage(page) && !isProductsByConditionDataSource(block)) {
    block.baseProductId = page.articleNumber;

    if (route?.query?.variant) {
      block.variantId = route.query.variant;
    }
  }
}

function buildProductData(data: any) {
  if (Array.isArray(data) && data.length > 0) {
    return {
      products: data,
      source: 'relation',
    };
  } else if (data?.products?.length > 0) {
    return {
      products: data.products,
    };
  }
}
